import React, { useState } from 'react';
import { completeMicrosoftSignup } from '../api/apiClient';
import './Login.css';
import './SsoOnboarding.css';

const TITLE_PLACEHOLDER = {
  'Partner':                   'e.g. Partner, Managing Partner',
  'Of Counsel/Senior Counsel': 'e.g. Of Counsel, Senior Counsel',
  'Associate':                 'e.g. Associate, Senior Associate',
  'Staff':                     'e.g. Paralegal, Office Manager, Intern',
};

const SsoOnboarding = ({ name, pendingToken, onComplete, onCancel }) => {
  const [roleCategory, setRoleCategory] = useState('');
  const [customTitle, setCustomTitle] = useState('');
  const [officeLocation, setOfficeLocation] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const firstName = name?.split(' ')[0] || '';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!roleCategory) { setError('Please select your role.'); return; }
    if (roleCategory === 'Staff' && !customTitle.trim()) { setError('Please enter your job title.'); return; }
    if (!officeLocation) { setError('Please select your office location.'); return; }

    setError(''); setLoading(true);
    try {
      const res = await completeMicrosoftSignup({
        pending_token: pendingToken,
        role_category: roleCategory,
        title: customTitle.trim(),
        office: officeLocation,
      });
      onComplete(res.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sso-overlay">
      <div className="sso-card">
        <h2 className="sso-title">Welcome, {firstName}!</h2>
        <p className="sso-subtitle">Before we get you in, we just need a couple more details.</p>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>Role</label>
            <select
              value={roleCategory}
              onChange={e => { setRoleCategory(e.target.value); setCustomTitle(''); }}
              className="login-select"
              required
            >
              <option value="" disabled>Select your role…</option>
              <option value="Partner">Partner</option>
              <option value="Of Counsel/Senior Counsel">Of Counsel / Senior Counsel</option>
              <option value="Associate">Associate</option>
              <option value="Staff">Staff</option>
            </select>
          </div>

          {roleCategory && (
            <div className="form-group">
              <label>Job Title</label>
              <input
                type="text"
                value={customTitle}
                onChange={e => setCustomTitle(e.target.value)}
                placeholder={TITLE_PLACEHOLDER[roleCategory]}
                required={roleCategory === 'Staff'}
              />
            </div>
          )}

          <div className="form-group">
            <label>Office Location</label>
            <select
              value={officeLocation}
              onChange={e => setOfficeLocation(e.target.value)}
              className="login-select"
              required
            >
              <option value="" disabled>Select your office…</option>
              <option value="Chicago">Chicago (Main)</option>
              <option value="Delaware">Delaware</option>
              <option value="Washington D.C.">Washington D.C.</option>
            </select>
          </div>

          {error && <p className="login-error">{error}</p>}

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? 'Setting up your account…' : 'Get Started'}
          </button>
          <button type="button" className="back-link" onClick={onCancel}>
            ← Cancel
          </button>
        </form>
      </div>
    </div>
  );
};

export default SsoOnboarding;
